import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { UserService } from '../../../user/user.service';
import { SnackBarService } from '../../../core/snack-bar.service';
import { QuillWrapperComponent } from 'src/app/common/quill-wrapper/quill-wrapper.component';

@Component({
    selector: 'app-user-notes-dialog',
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatDialogModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        MatIconModule,
        MatProgressSpinnerModule,
        QuillWrapperComponent,
    ],
    templateUrl: './user-notes-dialog.component.html',
    styleUrls: ['./user-notes-dialog.component.scss']
})
export class UserNotesDialogComponent implements OnInit {
  notesForm: FormGroup;
  isLoading = false;
  isSaving = false;
  notesMetadata: {
    created_by: string | null;
    created_at: string | null;
    updated_by: string | null;
    updated_at: string | null;
  } = {
    created_by: null,
    created_at: null,
    updated_by: null,
    updated_at: null
  };

  constructor(
    private fb: FormBuilder,
    private userService: UserService,
    private snackBarService: SnackBarService,
    public dialogRef: MatDialogRef<UserNotesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { userId: number }
  ) {
    this.notesForm = this.fb.group({
      admin_notes: ['', Validators.maxLength(5000)]
    });
  }

  ngOnInit(): void {
    this.loadUserNotes();
  }

  loadUserNotes(): void {
    this.isLoading = true;
    this.userService.getUserNotes(this.data.userId).subscribe({
      next: (response: any) => {
        if (response && response.admin_notes !== undefined) {
          this.notesForm.get('admin_notes')?.setValue(response.admin_notes || '');
          
          this.notesMetadata = {
            created_by: response.created_by_name || null,
            created_at: response.created_at || null,
            updated_by: response.updated_by_name || null,
            updated_at: response.updated_at || null
          };
        }

        this.isLoading = false;
      },
      error: (err) => {
        console.error('Error loading notes:', err);
        this.isLoading = false;
      }
    });
  }

  saveNotes(): void {
    if (this.notesForm.invalid) return;

    const notesValue = this.notesForm.get('admin_notes')?.value;
    const notes: string = notesValue !== undefined && notesValue !== null ? String(notesValue) : '';

    this.isSaving = true;
    this.userService.updateUserNotes(this.data.userId, notes).subscribe({
      next: () => {
        this.snackBarService.open('Notes saved successfully');
        this.dialogRef.close(true);
        this.isSaving = false;
      },
      error: (err) => {
        console.error('Error saving notes:', err);
        this.snackBarService.open('Failed to save notes');
        this.isSaving = false;
      }
    });
  }

  close(): void {
    this.dialogRef.close();
  }

  get adminNotesControl(): FormControl {
    return this.notesForm.get('admin_notes') as FormControl;
  }
}